import Project from './project'
import Project1 from './project1/project'
import Project2 from './project2/project'
import Project3 from './project3/project'
import Project4 from './project4/project'
import Project5 from './project5/project'
import Project6 from './project6/project'
import Project7 from './project7/project'
import Project8 from './project8/project'
import Project9 from './project9/project'
import Project10 from './project10/project'
import Project11 from './project11/project'
import Project12 from './project12/project'
import Project13 from './project13/project'

const ProjectContents = [
    /*<Project description={'BitácoraWP es un blog personal en el cual público artículos sobre los conocimientos, trucos, consejos que voy adquiriendo como desarrollador web y wordpress'}>
        <Project10/>
    </Project>,*/
    <Project description={'wikipelis es un aplicación creada en React en la que puedes ver información de diferentes peliculas. Consume el API de themoviedb.org'}>
        <Project11/>
    </Project>,
    <Project description={'Digital Cartas es una landing page que ofrece cartas figitales para restaurantes y demas negocios gastronomicos'}>
        <Project12/>
    </Project>,
    <Project description={'El encuentro es una carta digital muestra de una parrilleria ofrecida por digitalcartas.com'}>
        <Project13/>
    </Project>,
    <Project description={'SIPRO 3.0 es la nueva versión de un curso en linea SIPRO, la cual forma parte del diplomado en investigación científica que ofrece la Sociedad  Hispana de Investigadores científicos:'}>
        <Project1/>
    </Project>,
    <Project description={'Diplomado en investigación es el programa de diplomado que ofrece la Sociedad Hispana de Investigadores Científicos.'}>
        <Project2/>
    </Project>,
    <Project description={'BIOESTADISTICO es una empresa educativa que ofrece seminarios en vivo, cursos virtuales, seminarios online en Estadistica e investigación. Prar universidades u otras entidades educativas.'}>
        <Project3/>
    </Project>,
    <Project description={'Como Empezar una Tesis es una landing page la cual ofrece un seminario y un pdf por tu suscripcion gratuita.'}>
        <Project4/>
    </Project>,
    <Project description={'josesupo.com Es un sitio de presentación personal del Dr. José Supo. Cuenta con un blog de noticias .'}>
        <Project5/>
    </Project>,
    <Project description={'Carl Sagan Kinder. es una institución educativa para niños de 3, 4 y 5 años ubicada en Paucarpata, Arequipa - Perú.'}>
        <Project6/>
    </Project>,
    <Project description={'SINCIE o "Sociedad Hispana de Investigadores Científicos". Es una sociedad avocada a la investigación científica la cual alberga a mas de 2600 miembros en mas de 15 países.'}>
        <Project7/>
    </Project>,
    <Project description={'cursodespss.com es una plataforma de educación digital, la cual ofrece un curso de SPSS certificado por tu suscripción gratuita.'}>
        <Project8/>
    </Project>,
    <Project description={'TAPIF 3.0 es la nueva versión de un curso en linea TAPIF, la cual forma parte del diplomado en investigación científica que ofrece la Sociedad  Hispana de Investigadores científicos:'}>
        <Project9/>
    </Project>,
]

export default ProjectContents